import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import facebookEvents from "web/script/analytics/facebook-events";
import overlayMixin from "web/script/components/mixins/overlay-mixin";
import environment from "web/script/modules/environment";
import rothko from "web/script/modules/rothko";
import userProfiler from "web/script/modules/userprofiler";
import browser from "web/script/utils/browser";
import history from "web/script/utils/history";
import { base64Decode } from "web/script/utils/json";
import logging from "web/script/utils/logging";
import "web/script/components/email-capture-prompt";
import "web/script/components/follow-button";
import "web/script/components/image-gallery";
import "web/script/components/overlays/generic-overlay-launcher";
import "web/script/components/product-overview";
import "web/script/components/product-page-suggestions";
import "web/script/components/read-more-text";
import "web/script/components/recently-viewed";
import "web/script/components/related-products-loader";
import "web/script/components/save-for-later-button";
import "web/script/components/save-for-later-signup-prompt";
import renderReactComponentInDocument from "web/script/utils/render-react";
import ProductArea from "web/react/components/product-area/product-area";
export default baustein.register("product-overlay", {
  mixins: [overlayMixin],
  defaultOptions: {
    // overlay-mixin options
    overlaySize: "large",
    noContentPadding: true,
    // product-overlay options
    productSlug: null,
    productUid: null,
    linkId: null
  },
  setupEvents: function setupEvents(add) {
    add("selected", "product-card", this._onProductCardSelect);
    add("addedToBag", this._onAddedToBag);
  },
  renderProductArea: function renderProductArea() {
    if (document.querySelector(".product-in-stock-overlay__details")) {
      if (this.overlayContext.in_stock) {
        var inStock = this.overlayContext.in_stock;
        var productArea = inStock["product_area"];
        var productEditButton = inStock["product_edit_button"];
        renderReactComponentInDocument(ProductArea, {
          productArea: productArea,
          editButton: productEditButton,
          features: productArea.features
        }, document.querySelector(".product-in-stock-overlay__details"));
      }
    }
  },
  onOptionsChange: function onOptionsChange() {
    var _this = this;

    if (!this.el) {
      return;
    }

    this.el.scrollTop = 0;
    this.getOverlayContent().then(function (content) {
      _this.setContent(content);

      _this.renderProductArea();
    }).then(this.trackPageView.bind(this));
  },
  onOverlayOpen: function onOverlayOpen() {
    this.renderProductArea();
    this.trackPageView(); // Fix page on mobile to avoid background scrolling on ios

    if (browser.getViewport() === browser.VIEWPORTS.MOBILE) {
      this.emit("fixPageContent");
    }
  },
  onOverlayCloseIntent: function onOverlayCloseIntent() {
    history.back();

    if (browser.getViewport() === browser.VIEWPORTS.MOBILE) {
      this.emit("unFixPageContent");
    }
  },
  trackPageView: function trackPageView() {
    var container = this.el.querySelector(".product-overlay");

    if (!container) {
      console.warn("Cannot track page view for product overlay!");
      return;
    }

    var analyticsProductData = base64Decode(container.getAttribute("data-analytics-product")); // Save the seen product in the
    // user localstorage profile

    userProfiler.saveSeenProduct(analyticsProductData); // update environment variables

    environment.set({
      gaVariables: base64Decode(container.getAttribute("data-ga-dimensions")),
      analyticsProduct: analyticsProductData,
      pageType: "product_overlay",
      pageSubType: analyticsProductData.soldout ? "out_of_stock" : "in_stock",
      pageViewAnalytics: base64Decode(container.getAttribute("data-page-view"))
    }); // we add adroll via tag manager so don't know if it's there yet and we only want to use
    // them temporary so we are doing this the ugly way. will be better with doubleclick (haha, lol)

    try {
      window.__adroll.record_user({
        product_id: analyticsProductData.product_slug
      });
    } catch (err) {// do nothing
    }

    analytics.tagEvent(analytics.TAG_NETWORKS.FACEBOOK, facebookEvents.VIEW_CONTENT, {
      content_ids: [analyticsProductData.product_id],
      content_type: "product"
    });
  },
  getOverlayContent: function getOverlayContent() {
    var _this2 = this;

    var slug = this.options.productSlug;
    var uid = this.options.productUid;
    var linkId = this.options.linkId;
    return Promise.all([import(
    /* webpackChunkName: "template-product-overlay" */
    "templates/modules/product/product_overlay.jinja"), rothko.fetch("modules/product/product_overlay", {
      slug: slug,
      uid: uid,
      link_id: linkId
    })]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          template = _ref2[0].default,
          productOverlayContext = _ref2[1];

      _this2.overlayContext = productOverlayContext;
      return template({
        product_overlay: _this2.overlayContext,
        csrf_token: rothko.getCSRF()
      });
    }).catch(function (err) {
      logging.error(err);
    });
  },
  getOverlayContext: function getOverlayContext() {
    return this.overlayContext;
  },

  /**
   * Handles the 'selected' event from product-card components. Stops propagation so the event
   * does not bubble up any further.
   * @private
   */
  _onProductCardSelect: function _onProductCardSelect(event) {
    event.stopPropagation();
  },
  _onAddedToBag: function _onAddedToBag() {
    history.back();
  }
});